import classNames from "classnames";
import { Alert } from "react-bootstrap";
import { useLocation } from "react-router-dom";

const ForgotPasswordConfirmForm = ({
  layout,
}: {
  layout?: "simple" | "card" | "split";
}) => {
  const location = useLocation();
  const { email } = location.state || { email: "" };

  return (
    <div>
      <div className={classNames({ "px-xxl-5": !(layout === "split") })}>
        <div
          className={classNames("text-center", {
            "mb-6": !(layout === "split"),
          })}
        >
          <h4 className="text-body-highlight mb-3">Email enviado!</h4>
          <Alert variant="subtle-success" className="mb-4">
            <p className="mb-0">
              Se o email <strong>{email}</strong> estiver cadastrado em nosso
              sistema, enviamos um link para redefinição de senha.
            </p>
          </Alert>
          <p className="text-body-tertiary">
            Verifique sua caixa de entrada e clique no link enviado para criar
            uma nova senha. Se não encontrar o email, verifique também a pasta
            de spam.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordConfirmForm;
